import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Typography, Grid } from '@mui/material'
import { TextField, ModelMenuSelectorField } from '@front/squirtle'

const Title = props =>
  <Grid size={12}>
    <Typography variant={'h5'}> {I18n.t('setting.search')} </Typography>
  </Grid>

const Row1 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <TextField name={'name'} label={I18n.t('name.label', { count: 1 })} />
    </Grid>
    <Grid size="grow">
      <ModelMenuSelectorField
        name={'category'}
        label={I18n.t('category.label', { count: 1 })}
        model_name={'settingcategory'}
        labelKeys={['name']}
        searchMode={'search'}
        loadOnMount
      />
    </Grid>
  </Grid>

const SearchForm = props =>
  <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
    <Grid container rowSpacing={3}>
      <Title />
      <Row1 {...props} />
    </Grid>
  </Box>

export default React.memo(SearchForm)
